import { render, staticRenderFns } from "./productTable.vue?vue&type=template&id=77125436&scoped=true"
import script from "./productTable.vue?vue&type=script&lang=js"
export * from "./productTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77125436",
  null
  
)

export default component.exports